<script>
import { defineComponent } from 'vue'
import SquareButton from '../squareButton.vue'

export default defineComponent({
    name: 'table-editable-name',
    components: { SquareButton },
    props: {
        isEditing: {
            type: Boolean,
            required: true
        },
        data: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            required: true
        },
        editPrivilege: {
            type: Boolean,
            required: true
        }
    }
})
</script>

<template>

    <v-menu v-if="!isEditing"
            :nudge-bottom="4"
            :nudge-left="24"
            :open-delay="150"
            content-class="cell-edit-menu"
            offset-x
            open-on-hover
            right
    >
        <template #activator="{ on, attrs }">
            <div class="cell-hover-area"
                 v-bind="attrs"
                 v-on="on">
                    <span><template v-if="data.dynamic"><i
                        class="far fa-hashtag" />&nbsp;</template>{{ data.name }}</span>
            </div>
        </template>
        <template v-if="editPrivilege" #default>
            <square-button icon="far fa-pencil"
                           style="opacity: 0.8"
                           @click="$emit('cellEditEnable')" />
        </template>
    </v-menu>

    <div v-else
         class="textarea-container">

        <i v-if="data.dynamic"
           class="far fa-hashtag"
           style="position: absolute; left: 1rem; top: calc(1rem + 4px); z-index: 1;" />
        <v-textarea :class="{'indented': data.dynamic}"
                    :row-height="32"
                    :value="value"
                    auto-grow
                    autofocus
                    class="textarea-cell-editing"
                    hide-details
                    outlined
                    rows="1"
                    style="margin: -10px -12px 0; max-width: unset; font-size: inherit; line-height: inherit;"
                    @input="$emit('input', $event)"
                    @keydown.enter.exact.prevent
                    @keyup.enter.exact="$emit('cellEditConfirm')"
                    @keyup.esc.exact="$emit('cellEditCancel')"
        />

        <div
            style="max-height: fit-content; display: flex; justify-content: end; margin-top:0.25rem; margin-inline-end: -12px; margin-block-end: -12px;">

            <v-btn
                icon
                @click="$emit('cellEditCancel')">
                <v-icon small>far fa-xmark</v-icon>
            </v-btn>
            <v-btn
                icon
                @click="$emit('cellEditConfirm')">
                <v-icon small>far fa-check</v-icon>
            </v-btn>
        </div>
    </div>
</template>

